import React from 'react';
import { useGetTagsQuery } from '../../Tags/Service/tagsApi';
import {
  mapTagToBookingExpenseInvoiceLookup,
  type BookingExpenseInvoiceTagShape,
  type BookingExpenseInvoiceTagLookup,
} from './bookingExpenseInvoiceTagsLookupMapper';

type TagsQueryOptions = Parameters<typeof useGetTagsQuery>[1];
type TagsQueryResult = ReturnType<typeof useGetTagsQuery>;

type BookingExpenseInvoiceTagsLookupQueryResult = Pick<
  TagsQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data: BookingExpenseInvoiceTagLookup[];
};

export const useGetBookingExpenseInvoiceTagsLookupQuery = (
  options?: TagsQueryOptions
): BookingExpenseInvoiceTagsLookupQueryResult => {
  const queryResult = useGetTagsQuery(undefined, options);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((tag: BookingExpenseInvoiceTagShape) => mapTagToBookingExpenseInvoiceLookup(tag))
        .filter(
          (tag: BookingExpenseInvoiceTagLookup | undefined): tag is BookingExpenseInvoiceTagLookup =>
            Boolean(tag)
        ),
    [queryResult.data]
  );

  return {
    data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};

